<template>
    <div class="messagePage">
        <div class="content" v-if="!hasMessage">
            <img src="../../assets/images/sc@2x.png" />
            <p class="text">暂无任何消息</p>
        </div>
        <div class="message-content" v-if="hasMessage">
            <ul class="message-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="30" infinite-scroll-immediate-check="true">
                <li class="item" v-for="(item, index) in messageList" :key="index">
                    <div class="date-show" v-if="item.dateFirst"><span>{{item.dateFirst}}</span></div>
                    <div class="detail-body">
                        <div class="detail-content">
                            <div class="header">
                                <span class="message-title">{{item.title}}</span>
                                <span class="message-time">{{item.date}} {{item.time}}</span>
                            </div>
                            <div class="detail">
                                <p v-html="item.message.replace(/<(\/?br.*?\/)>/gi, ' ')"></p>
                                <!--<p v-html="item.message"></p>-->
                            </div>
                        </div>
                        <div class="detail-footer" @click="toDetail(item)">
                            <span>详情</span>
                            <img class="image" src="../../assets/images/ou@2x.png"/>
                        </div>
                    </div>
                </li>

                <div class="warm-tips" v-if="!hasMore">已经到最底了</div>
            </ul>
        </div>
    </div>
</template>

<script>
  import { userInfo, messageApi } from '@/apis'
  import { mapState } from 'vuex'
  // import axios from 'axios'
  export default {
    data(){
      return{
        hasMessage: 'no',
        patientId: '',
        // openid: 'o0wDk01IOru4dCuPnRko8Y8JznGk',
        messageList: [],
        currentTimestamp: '',
        loading: false,
        hasMore: true,
        pageNo: 1,
        pageSize: 5
      }
    },
    created(){
      if(this.openid==null||this.openid==undefined||this.openid=='null' || this.openid=='undefined'||this.openid=='' || !this.openid){
        this.hasMessage = false;
        return
      }else {
        this.patientInfo();
      }
    },
    computed: {
      ...mapState({
        openid: state => state.openid,
      })
    },
    methods: {
      patientInfo(){
        this.axios.get(userInfo.queryPatientsInfo,{
          params: {
            openId: this.openid,
          }
        }).then(res=>{
          let data = res.data;
          if(data.code === '000000'){
            if(data.data.hasBinded === true){
              this.patientId = data.data.patientDto.id;
              this.init(this.patientId, this.pageNo, this.pageSize);
            }else {
              this.$toast('您还未绑定个人信息');
              this.hasMessage = false;
            }
          }
        })
      },
      init(patientId, pageNo, pageSize){
        if (this.loading || !this.hasMore) return; // 正在执行加载动作 或者 没有更多数据，直接返回
        this.loading = true; // 标记正在执行加载数据动作
        this.axios.get(messageApi.getMessage,{
          params:{
            patientId: patientId,
            pageNo: pageNo,
            pageSize: pageSize
          }
        }).then(res => {
          let data = res.data;
          // console.log('logs',data)
          if(data.code === '000000'){
            let messageList = data.data.logs;
            console.log('messageList',messageList);
            if(messageList.length === 0){
              this.hasMore = false;
            }
            this.messageList = this.messageList.concat(messageList);
            if(this.messageList.length > 0){
              this.hasMessage = true;
              this.currentTimestamp = messageList[0].date;
              this.messageList[0].dateFirst = messageList[0].date;

              for(let i = 0; i < this.messageList.length; i++){
                let dateEvery = this.messageList[i].date;
                if(this.currentTimestamp !== dateEvery){
                  this.messageList[i].dateFirst = dateEvery;
                  this.currentTimestamp = dateEvery;
                }
              }
              // this.messageList = this.messageList.concat(messageList);
              if(messageList.length > 4){
                this.pageNo++;
                this.loading = false;
                this.hasMore = true;
              } else {
                this.hasMore = false;
              }

              // this.hasMore = false;
            }else {
              this.hasMessage = false;
            }
          }
        })
      },
      loadMore(){
        // if(this.loading || !this.hasMore){
        //   return;
        // }
        console.log('123123')
        this.init(this.patientId, this.pageNo, this.pageSize);
        // this.loading = true;
      },
      toDetail(obj){
        this.$router.push({
          path: '/messageDetail',
          query: obj,
        })
      }
    }
  }
</script>
<style scoped lang="scss">
@import '../../assets/css/common.css';
.messagePage {
    /*width: 100%;*/
    /*height: 100%;*/
    /*min-height: 100vh;*/
    width:375px;
    height:100%;
    /*min-height: 667px;*/
    background: #F8F8F8;
    .content {
      width:375px;
      height:100%;
      overflow: hidden;
      padding-top: 111px;
        img {
            width: 150px;
            height:150px;
            margin: 0 auto;
        }
        .text {
            width: 100px;
            height: 21px;
            line-height: 21px;
            font-size: 15px;
            color: #999;
            margin: 0 auto;
        }
    }
    .message-content{
        box-sizing: border-box;
        padding: 2px 15px 20px;
        .message-list{
            /*padding-bottom: 15px;*/
            .item{
                padding-top: 15px;
                .date-show{
                    text-align: center;
                    padding-bottom: 15px;
                    span{
                        display: inline-block;
                        padding: 0px 10px;
                        background-color: #DCDCDC;
                        height: 18px;
                        line-height: 18px;
                        font-size: 12px;
                        color: #ffffff;
                        border-radius: 9px;
                    }
                }
                .detail-body{
                    width: 100%;
                    background-color: #ffffff;
                    border-radius: 6px;
                    .detail-content{
                        padding: 15px 15px 0;
                        .header{
                            @include flex;
                            @include justify-content(space-between);
                            .message-title{
                                font-size: 14px;
                                color: #333333;
                                line-height: 16px;
                                @include flex-value(1)
                            }
                            .message-time{
                                font-size: 12px;
                                color: #B4B4B4;
                                line-height: 16px;
                            }
                        }
                        .detail{
                            padding: 10px 0;
                            font-size: 13px;
                            color: #999999;
                            line-height: 18px;
                            height: 56px;
                            p{
                                overflow: hidden;
                                text-overflow:ellipsis;
                                display:-webkit-box;
                                -webkit-box-orient:vertical;
                                -webkit-line-clamp:2;
                            }
                        }
                    }
                    .detail-footer{
                        border-top: 1PX solid #F0F0F0;
                        padding: 10px 10px 10px 15px;
                        @include flex;
                        @include justify-content(space-between);
                        @include align-items;
                        span{
                            width: 70px;
                            height: 27px;
                            line-height: 27px;
                            color: #A0DBD3;
                            border: 1PX solid #A0DBD3;
                            border-radius: 2px;
                            display: inline-block;
                            text-align: center;
                            box-sizing: border-box;
                        }
                        .image{
                            width: 25px;
                            height: 25px;
                        }
                    }
                }
            }
            .warm-tips{
              text-align: center;
              margin-top: 15px;
              color: #666666;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/message/message.vue